import type { Request } from 'express';
import type { MappedHttpRequest, SendErrorResponse } from "../core/types";
import { BaseErrorUtility } from '../core/baseUtility';

/**
 * Implements request mapping for Express.  
 * See `sendErrorFromEndPoint` method.
 */
export class ExpressErrorUtility extends BaseErrorUtility<Request> {
    protected mapRequest(req: Request): MappedHttpRequest {
        const headers = req.headers;
        const method = req.method.toUpperCase();
        const [url] = req.originalUrl.split("?");

        return {
            method,
            url,
            requestBody: req.body && Object.keys(req.body).length ? req.body : null,
            query: Object.keys(req.query).length ? req.query : null,
            headers: Object.keys(headers).length ? headers : null,
        };
    }

    /**
     * Sends error and Express request details to try-catch-cloud service.  
     * ```
     * app.use((error, req, res, next) => {
     *  errorUtility.sendErrorFromEndPoint(error, req)
     *     .catch((e) => { ... });
     *
     *   res.status(500).json({ message: "Internal server error" });
     * });
     * ```
     */
    async sendErrorFromEndPoint (error: unknown, request: Request, userContext?: Record<string, unknown> | undefined): Promise<SendErrorResponse> {
        return super.sendErrorFromEndPoint(error, request, userContext);
    }
}
